import { createContext, useContext } from 'react';

const STORAGE_KEY = 'sidebarOpen';

export function loadSidebarState(): boolean {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : true;
  } catch (error) {
    console.warn('Could not load sidebar state from localStorage', error);
    return true;
  }
}

export function saveSidebarState(value: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    console.warn('Could not save sidebar state to localStorage');
  }
}

export interface SidebarContextProps {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
}

export const SidebarContext = createContext<SidebarContextProps | undefined>(undefined);

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar must be used inside SidebarProvider');
  return ctx;
}
